export default __webpack_public_path__ + "images/4a9d5694a530e1d4ce491a6830c39ddf-adopt-dog-background-670.png";